import {Submission, IAddress, IQuestionResponse, ISubmission, ILocationAggregate, LocationAggregate} from './models';

export interface ISubmissionRequest extends ISubmission {
    locations: ILocationAggregate[];
    questionResponses: IQuestionResponse[];
    mailingAddress: IAddress;
    primaryContactId: string;
}

export class SubmissionRequest extends Submission implements ISubmissionRequest {
    public locations: LocationAggregate[];
    public questionResponses: IQuestionResponse[];
    public mailingAddress: IAddress;
    public primaryContactId: string;
}